<template>
  <div class="container">
    <div class="container page_banner ">
      <div class='page_width'>
         <div class="banner_gruop" >
            <div class="banner_title"> <span class="color3"></span> Marketplace Payments That Scale</div>
            <div class="banner_tips mt-40 fw-300">Transform your marketplace with secure, scalable payment infrastructure. Focus on growth while we handle fast, reliable transactions.</div>
             <router-link to="contact-us"><span class=" pointer color1 py-10 px-20 border-default mt-20 fs-f20 bg_3 dis-i-b" >Get Started</span></router-link>
          </div>
       </div>
    </div>

    <div class="container pb-50"> 
      <div class="page_top" >
        <div class="page_width" > 
          <div class="py-20">
              <div class="grid grid_md_gap grid_xs_gap" >
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_col_start" >
                  <!-- <div class="flex_col_start"> -->
                    <div class="page_title pb-30">
                      <div class="title_name color1 text-l">Why Corelinkpay for Marketplaces?</div>
                      <div class="title_tag color1 text-l">Features that drive success</div>
                    </div>
                    <div class="tab_group text-l mt-20" :class="[show1?'active_item':'']">
                        <div class="half_title fs-30 pointer" @click="showOne(1)">Effortless Pay-Ins and Pay-Outs</div>
                        <el-collapse-transition>
                          <div class="half_text color1 fs-14 fw-300" v-show="show1">Simplify transactions with streamlined pay-in and pay-out processes, optimized for speed and reliability.</div>
                        </el-collapse-transition>
                    </div>
                    <div class="tab_group text-l mt-20" :class="[show2?'active_item':'']">  
                        <div class="half_title fs-30 pointer" @click="showOne(2)">Intuitive User Experience</div>
                        <el-collapse-transition>
                           <div class="half_text color1 fs-14 fw-300" v-show="show2">Delight buyers and sellers with a seamless, user-friendly payment interface designed for convenience.</div>
                        </el-collapse-transition>
                    </div>
                    <div class="tab_group text-l mt-20" :class="[show3?'active_item':'']">
                        <div class="half_title fs-30 pointer" @click="showOne(3)">Smart Payment Routing</div>
                        <el-collapse-transition>
                           <div class="half_text color1 fs-14 fw-300" v-show="show3">Our AI-driven routing ensures transactions are processed efficiently, minimizing delays and costs.</div>
                        </el-collapse-transition>
                    </div>
                    <div class="tab_group text-l mt-20" :class="[show4?'active_item':'']">
                        <div class="half_title fs-30 pointer" @click="showOne(4)">Diverse Payment Options</div>
                        <el-collapse-transition>
                           <div class="half_text color1 fs-14 fw-300" v-show="show4">Offer a wide range of popular payment methods to cater to your customers’ preferences.</div>
                        </el-collapse-transition>
                    </div>
                  <!-- </div> -->
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img src="../../assets/image/t22.png" alt="">
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container page_title_bg pt-80 pb-50" > 
      <div class="" >
        <div class="page_width" >
          <div class="page_title">
            <div class="title_name color1">Unleash the Power of AI-Powered Analytics</div>
            <div class="title_tag color1">Gain a competitive edge with Corelinkpay’s advanced analytics tools. Our platform provides:</div>
          </div>
          <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <!-- <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb20.png" alt="" class="">
                        </div> -->
                        <div class="half_title color1 fs-22">Cust Behavior Insights</div>
                        <div class="line"></div>
                        <div class="half_text color1 mt-10 fs-16 fw-300">Understand your users with detailed segmentation and predictive algorithms.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <!-- <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb21.png" alt="" class="">
                        </div> -->
                        <div class="half_title color1 fs-22">Real-Time Data</div>
                        <div class="line"></div>
                        <div class="half_text color1 mt-10 fs-16 fw-300">Monitor transactions and trends to make informed business decisions.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <!-- <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb22.png" alt="" class="">
                        </div> -->
                        <div class="half_title color1 fs-22">Actionable Forecasting</div>
                        <div class="line"></div>
                        <div class="half_text color1 mt-10 fs-16 fw-300">Anticipate market demands with AI-driven forecasting tools.</div>
                    </div>
                </div>
               
              </div>
          </div>
        </div>
      </div>
    </div>


    
    <div class="container "> 
      <div class="page_top" >
        <div class="page_width" > 
          <div class="py-20">
              <div class="grid grid_md_gap grid_xs_gap" >
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img src="../../assets/image/t4.png" alt="">
                  </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_col_start" >
                    <div class="page_title pb-30">
                      <div class="title_name color1 text-l">Global Reach with Open Banking</div>
                      <div class="title_tag color1 text-l">Corelinkpay is a leading global payment platform and open banking provider. Through secure data-sharing with trusted banks</div>
                    </div>
                    <div class="tab_group text-l mt-20" :class="[show1_2?'active_item':'']">
                        <div class="half_title fs-30 pointer" @click="showOne_2(1)">Connected Banking Network</div>
                        <el-collapse-transition>
                          <div class="half_text color1 fs-14 fw-300" v-show="show1_2">Integrate with major banks across the UK, EU, and beyond for effortless payments.</div>
                        </el-collapse-transition>
                    </div>
                    <div class="tab_group text-l mt-20" :class="[show2_2?'active_item':'']">  
                        <div class="half_title fs-30 pointer" @click="showOne_2(2)">AI-Enhanced Solutions</div>
                        <el-collapse-transition>
                           <div class="half_text color1 fs-14 fw-300" v-show="show2_2">Leverage machine-learning technology for smarter, more secure transaction processing.</div>
                        </el-collapse-transition>
                    </div>
                    <div class="tab_group text-l mt-20" :class="[show3_2?'active_item':'']">
                        <div class="half_title fs-30 pointer" @click="showOne_2(3)">Scalable Growth Plans</div>
                        <el-collapse-transition>
                           <div class="half_text color1 fs-14 fw-300" v-show="show3_2">From small marketplaces to global platforms, our flexible solutions grow with you..</div>
                        </el-collapse-transition>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container page_title_bg"> 
      <div class="py-80" >
        <div class="page_width" >
            <div class="page_title pb-30">
                <div class="title_name color1 ">What is a Payment Gateway?</div>
                <div class="title_tag color1">A payment gateway acts as a secure bridge, seamlessly transferring financial data between customers, sellers, and banks. With Corelinkpay, every transaction is fast, safe, and optimized for your marketplace’s success.</div>
            </div>
       
        </div>
      </div>
    </div>

    

    <div class="container bg_2"> 
      <div class="" >
        <div class="page_width" >
          <div class="py-80" >
            <div class="page_title ">
                <div class="title_name color1 ">FAQs</div> 
            </div>
            <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_12 grid_xs_12 grid_sm_12 ">
                     <div class="faq_collapse">
                        <el-collapse v-model="activeName" accordion>
                          <el-collapse-item title="How fast are transactions processed?" name="1">
                            <div class="coll_item">Funds are available in your account within minutes, thanks to our instant transaction technology.</div> 
                          </el-collapse-item>
                          <el-collapse-item title="Is Corelinkpay secure for marketplaces?" name="2">
                           <div class="coll_item">Yes, our platform uses advanced encryption and AI-powered fraud detection to ensure every transaction is protected.</div>
                          </el-collapse-item>
                          <el-collapse-item title="Can I integrate Corelinkpay with my existing platform?" name="3">
                           <div class="coll_item">Absolutely! Our streamlined APIs make integration quick and easy, getting your marketplace up and running in no time.</div>
                          </el-collapse-item>
                        </el-collapse>
                      </div>
                </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <div class="container">
      <div class="page_width">
        <div class="pt-20 pb-80">
            <div class="grid grid_md_gap grid_xs_gap">
              <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center">
                <div class="w-100p">
                  <img src="../../assets/image/t32.png" alt="">
                </div>
              </div>
              <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center">
                  <div class="page_title ">
                      <div class="title_name color1 text-l">Tools to Supercharge Your Marketplace</div>
                      <div class="title_tag color1 text-l">Experience the efficiency of instant payments, seamless integrations, and powerful analytics. With CorelinkPay, your marketplace can focus on growth while we take care of the payments.</div>
                  </div>
              </div>
            </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>

export default {
    data(){
        return{
           
            activeName:'1',
            show1:true,
            show2:false,
            show3:false,
            show4:false,
            show1_2:true,
            show2_2:false,
            show3_2:false,
           
        }
    },
     methods:{
      showOne(tab){
        if(this.show1 && tab == 1 || this.show2 && tab == 2 || this.show3 && tab == 3 || this.show4 && tab == 4){
          this.show1 = false
          this.show2 = false
          this.show3 = false
          this.show4 = false
          return
        }
        switch (tab) {
          case 1:
            this.show1 = true
            this.show2 = false
            this.show3 = false
            this.show4 = false
            break;
          case 2:
            this.show1 = false
            this.show2 = true
            this.show3 = false
            this.show4 = false
            break;
          case 3:
            this.show1 = false
            this.show2 = false
            this.show3 = true
            this.show4 = false
            break;
          case 4:
            this.show1 = false
            this.show2 = false
            this.show3 = false
            this.show4 = true
            break;
          default:
            break;
        }
      },
      showOne_2(tab){
        if(this.show1_2 && tab == 1 || this.show2_2 && tab == 2 || this.show3_2 && tab == 3 ){
          this.show1_2 = false
          this.show2_2 = false
          this.show3_2 = false
          
          return
        }
        switch (tab) {
          case 1:
            this.show1_2 = true
            this.show2_2 = false
            this.show3_2 = false
            this.show4 = false
            break;
          case 2:
            this.show1_2 = false
            this.show2_2 = true
            this.show3_2 = false
            this.show4 = false
            break;
          case 3:
            this.show1_2 = false
            this.show2_2 = false
            this.show3_2 = true
            this.show4 = false
            break;
         
          default:
            break;
        }
      }
    }
}
</script>

<style lang="scss" scoped>
.page_banner{
    background-image:url( ../../../public/bg/bn_bg4.png);
}
.tab_group{
  padding-left:20px;
  position: relative;
  .half_title{
    color:$theme_color1;
     position: relative;
      &::before{
        content: "";
        position: absolute;
        left: -20px;
        top: 18px;
        width: 8px;
        height: 8px;
        border-left: 3px solid #dddddd;
        border-top: 3px solid #dddddd;
        transition: all 0.35s ease-in-out;
        transform: rotate(135deg);
      }
  }
 
}
.active_item{
  .half_title{
      color: $theme_color3;
      position: relative;
      &::before{
        border-left: 3px solid $theme_color3;
        border-top: 3px solid $theme_color3;
        transform: rotate(225deg);
      }
  }
   

}
.line{
  height: 2px;
  width: 100%;
  margin:20px 0;
  background:#fff;
}



</style>